import ComparePanel from './ComparePanel';

export default ComparePanel;